import { Pipe, PipeTransform } from '@angular/core';

import { HabilitationDto } from '../../models/habilitation-dto.model';
import { HabilitationStatesEnum } from '../../models/habilitation-type.model';

@Pipe({
  name: 'habilitationCount',
  pure: false
})
export class HabilitationCountPipe implements PipeTransform {

  /**
   * Find number of habilitation that are open, pending or close
   * @param habilitationList Habilitation list
   * @param states Habilitation states
   * @returns Number of habilitations with one or more specific states
   */
  transform(habilitationList: Array<HabilitationDto>, states: Array<HabilitationStatesEnum>): number {
    return habilitationList.filter(h => states.includes(h?.etat as HabilitationStatesEnum)).length;
  }

}
